document.addEventListener('DOMContentLoaded', () => {

  console.log('UK Minimum Order script loaded');

  const MIN_ORDER_VALUE = 50000; // £500 in pence
  const MIN_ORDER_FORMATTED = '£500.00';
  const MESSAGE_TEXT = `Minimum order value for UK delivery is ${MIN_ORDER_FORMATTED}. Please add more items to proceed to checkout.`;

  // Converts a displayed price to pence without relying on the store's thousands
  // and decimal separators. For example, both "£1,137.20" and "£1.137,20"
  // result in 113720.
  function getPriceInPence(priceText) {
    const numericText = String(priceText || '').replace(/[^0-9.,]/g, '');
    if (!numericText || !/\d/.test(numericText)) return null;

    const lastDot = numericText.lastIndexOf('.');
    const lastComma = numericText.lastIndexOf(',');
    const decimalIndex = Math.max(lastDot, lastComma);
    const decimalDigits = decimalIndex === -1 ? '' : numericText.slice(decimalIndex + 1);
    const hasDecimalPart = decimalDigits.length > 0 && decimalDigits.length <= 2;

    if (hasDecimalPart) {
      const wholePart = numericText.slice(0, decimalIndex).replace(/[.,]/g, '');
      const fractionPart = decimalDigits.padEnd(2, '0');
      return Number(wholePart || '0') * 100 + Number(fractionPart);
    }

    // A separator followed by three digits is a thousands separator (e.g. 1,137).
    return Number(numericText.replace(/[.,]/g, '')) * 100;
  }

  function getCartTotal() {
    const subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (subtotalEl) {
      return getPriceInPence(subtotalEl.textContent);
    }
    return null;
  }

  function createMinOrderMessage(container) {
    const existing = container.querySelector('.uk-min-order-message');
    if (existing) return existing;
    const msg = document.createElement('div');
    msg.className = 'uk-min-order-message';
    msg.textContent = MESSAGE_TEXT;
    container.insertBefore(msg, container.firstChild);
    return msg;
  }

  // === CART PAGE ===
  function handleCartPage() {
    const cartForm = document.querySelector('form[action="/cart"]');
    if (!cartForm) return;

    const checkoutBtn = cartForm.querySelector('[name="checkout"]');
    const buttonsContainer = cartForm.querySelector('.cart__buttons-container');
    const additionalCheckout = cartForm.querySelector('.additional-checkout-buttons');

    function updateCartPage() {
      const total = getCartTotal();
      if (total === null) return;
      const belowMin = total < MIN_ORDER_VALUE;

      if (checkoutBtn) {
        checkoutBtn.disabled = belowMin;
        checkoutBtn.classList.toggle('btn--disabled', belowMin);
      }

      if (additionalCheckout) {
        additionalCheckout.style.display = belowMin ? 'none' : '';
      }

      if (buttonsContainer) {
        const msg = buttonsContainer.querySelector('.uk-min-order-message');
        if (belowMin) {
          if (!msg) createMinOrderMessage(buttonsContainer);
        } else if (msg) {
          msg.remove();
        }
      }
    }

    updateCartPage();

    // Re-check after AJAX cart updates
    const subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (subtotalEl) {
      const observer = new MutationObserver(() => updateCartPage());
      observer.observe(subtotalEl, { childList: true, characterData: true, subtree: true });
    }
  }

  // === QIKIFY STICKY CART WIDGET ===
  function handleQikifyCart() {
    function getQikifyTotal() {
      // .qsc2-drawer-footer__summary-subtotal-price contains div(s) with the price
      const subtotalEl = document.querySelector('.qsc2-drawer-footer__summary-subtotal-price');
      if (!subtotalEl) return null;
      const priceEls = subtotalEl.querySelectorAll('div');
      // Take the last div (could be discounted price) or the only one
      const priceEl = priceEls.length > 0 ? priceEls[priceEls.length - 1] : null;
      if (!priceEl) return null;
      return getPriceInPence(priceEl.textContent);
    }

    function updateQikify() {
      const checkoutBtn = document.querySelector('.qsc2-checkout-button');
      const footerCheckout = document.querySelector('.qsc2-drawer-footer__checkout');
      const mainSection = document.querySelector('.qsc2-drawer-footer__checkout__main-section');

      const total = getQikifyTotal();
      if (total === null) return;
      const belowMin = total < MIN_ORDER_VALUE;

      if (checkoutBtn) {
        checkoutBtn.disabled = belowMin;
        checkoutBtn.style.opacity = belowMin ? '0.5' : '';
        checkoutBtn.style.pointerEvents = belowMin ? 'none' : '';
      }

      // Hide any additional payment buttons inside main section (e.g. PayPal)
      if (mainSection) {
        mainSection.querySelectorAll('[id*="paypal"], .shopify-payment-button, .dynamic-checkout__content').forEach(el => {
          el.style.display = belowMin ? 'none' : '';
        });
      }

      if (footerCheckout) {
        const msg = footerCheckout.querySelector('.uk-min-order-message');
        if (belowMin) {
          if (!msg) {
            const newMsg = document.createElement('div');
            newMsg.className = 'uk-min-order-message uk-min-order-message--qikify';
            newMsg.textContent = MESSAGE_TEXT;
            footerCheckout.insertBefore(newMsg, footerCheckout.firstChild);
          }
        } else if (msg) {
          msg.remove();
        }
      }
    }

    // Observe the entire qikify app container for changes (Vue app re-renders)
    const qikifyApp = document.querySelector('#qikify-stickycart-v2-app');
    if (qikifyApp) {
      updateQikify();
      const observer = new MutationObserver(() => updateQikify());
      observer.observe(qikifyApp, { childList: true, characterData: true, subtree: true });
      return;
    }

    // If not yet in DOM, poll for it
    let attempts = 0;
    const interval = setInterval(() => {
      const app = document.querySelector('#qikify-stickycart-v2-app');
      if (app) {
        clearInterval(interval);
        updateQikify();
        const observer = new MutationObserver(() => updateQikify());
        observer.observe(app, { childList: true, characterData: true, subtree: true });
      } else if (++attempts > 60) {
        clearInterval(interval);
      }
    }, 500);
  }

  // === INTERCEPT /checkout NAVIGATION ===
  function interceptCheckoutNavigation() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href*="/checkout"]');
      if (!link) return;

      e.preventDefault();
      fetch('/cart.json')
        .then(r => r.json())
        .then(cart => {
          if (cart.total_price >= MIN_ORDER_VALUE) {
            window.location.href = link.href;
          } else {
            alert(MESSAGE_TEXT);
          }
        });
    }, true);
  }

  // === INTERCEPT FORM SUBMIT TO /checkout ===
  function interceptCheckoutForm() {
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form || form.tagName !== 'FORM') return;

      const submitBtn = form.querySelector('[name="checkout"]');
      if (!submitBtn) return;
      if (submitBtn.disabled) {
        e.preventDefault();
        return;
      }

      // Double-check via cart data attribute
      const subtotalEl = document.querySelector('[data-cart-subtotal]');
      if (subtotalEl) {
        const total = getPriceInPence(subtotalEl.textContent);
        if (total !== null && total < MIN_ORDER_VALUE) {
          e.preventDefault();
          alert(MESSAGE_TEXT);
        }
      }
    }, true);
  }

  // Init
  handleCartPage();
  handleQikifyCart();
  interceptCheckoutNavigation();
  interceptCheckoutForm();
});
